import React from 'react';
import { Cascader } from 'antd';
import cityData from '@jiumao/china-city-data';

export default class CitySelect extends React.Component {
  componentDidMount() {}

  render() {
    const { className, valueType, ...rest } = this.props;

    return (
      <Cascader
        style={{ width: '100%' }}
        options={cityData}
        {...rest}
        fieldNames={{
          label: 'n',
          value: 'n',
          children: 'c'
        }}
      />
    );
  }
}
